import {
  GET_COMPANIES_FAIL,
  GET_COMPANIES_SUCCESS,
  GET_COMPANY_DETAIL_FAIL,
  GET_COMPANY_DETAIL_SUCCESS,
  ADD_COMPANY_SUCCESS,
  ADD_COMPANY_FAIL,
  UPDATE_COMPANY_SUCCESS,
  UPDATE_COMPANY_FAIL,
  DELETE_COMPANY_SUCCESS,
  DELETE_COMPANY_FAIL,
} from "./actionTypes"

const INIT_STATE = {
  companies: [],
  companyDetail: {},
  error: {},
}

const Companies = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_COMPANIES_SUCCESS:
      return {
        ...state,
        error: {},
        companies: action.payload,
      }

    case GET_COMPANIES_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case GET_COMPANY_DETAIL_SUCCESS:
      return {
        ...state,
        error: {},
        companyDetail: action.payload,
      }

    case GET_COMPANY_DETAIL_FAIL:
      return {
        ...state,
        companyDetail: {},
        error: action.payload,
      }

    case ADD_COMPANY_SUCCESS:
      return {
        ...state,
        error: {},
        companyDetail: action.payload,
        companies: [...state.companies, action.payload],
      }

    case ADD_COMPANY_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case UPDATE_COMPANY_SUCCESS:
      return {
        ...state,
        error: {},
        companyDetail: action.payload,
        companies: state.companies.map(company =>
          company.id.toString() === action.payload.id.toString()
            ? { company, ...action.payload }
            : company
        ),
      }

    case UPDATE_COMPANY_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case DELETE_COMPANY_SUCCESS:
      return {
        ...state,
        error: {},
        companies: state.companies.filter(
          company => company.id.toString() !== action.payload.id.toString()
        ),
      }

    case DELETE_COMPANY_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    default:
      return state
  }
}

export default Companies
